<template>
	<div class="header">
		<div class="header-wrap">

			<div class="logo">
				<h1 class="glow-reflect-text">阆中分类信息网</h1>
			</div>

			<div class="search-box">
				<el-input placeholder="搜索信息/商家" class="search-input">
					<el-button slot="append" type="primary">搜索</el-button>
				</el-input>
			</div>

			<el-button type="danger" @click="$router.push('/publish')">
				<i class="el-icon-edit"></i> 信息发布
			</el-button>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'Header'
	}
</script>

<style lang="scss" scoped>
	.header {
		.header-wrap {
			width: 1200px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 50px 0;

			.search-input {
				width: 500px;
			}
		}

		.el-menu {
			border: none;
		}
	}


	.glow-reflect-text {
		font-weight: 900;
		color: #FF9966;
		text-shadow:
			0 0 5px rgba(255, 0, 204, 0.5),
			0 0 10px rgba(51, 51, 255, 0.5),
			0 0 20px rgba(0, 255, 153, 0.5),
			0 0 40px rgba(0, 255, 153, 0.5);
		animation: glow 2s ease-in-out infinite alternate;
	}

	@keyframes glow {
		from {
			text-shadow: 0 0 5px #fff, 0 0 10px #CCFF99, 0 0 20px #CCFF99;
		}

		to {
			text-shadow: 0 0 10px #fff, 0 0 20px #CCFF99, 0 0 60px #CCFF99, 0 0 80px #CCFF99;
		}
	}
</style>